module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_6005.43881256.png";